/**
 * Route for `real-time-click-fraud-detection`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeClickFraudDetectionPage } from "../features/real-time-click-fraud-detection/RealTimeClickFraudDetectionPage";

export const realTimeClickFraudDetectionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-click-fraud-detection",
	component: RealTimeClickFraudDetectionPage,
});

export default realTimeClickFraudDetectionRoute;
